import { getJsonRequest, postJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_URL } from '../config/settings/environment'
import factoryAuthService from '../modules/requests/services'

/**
 * Get the Traded Amount's data by Id Entity and Year
 */
export const createTradedAmounts = factoryAuthService(({ updatedValue }) => {
  const body = {
    idEntity: updatedValue.idEntity,
    years: updatedValue.years
  }

  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/calculo/montoacumulado`, { body })
})

/**
 * Get the Buying Modalitie's data by Id Entity and Year
 */
export const getBuyingModalities = factoryAuthService(({ idEntity, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/modalidad/compra/${idEntity}/${year}`)
)

/**
 * Get the Biddings Distribution's data by Id Entity , Type and Year
 */
export const getBiddingsDistribution = factoryAuthService(({ idEntity, year, type }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sankey/getSankey/${year}/${idEntity}/${type}`)
)

/**
 * Get the Main Biddings Indicator's data by Id Entity and Year
 */
export const getBiddingMoreOffers = factoryAuthService(({ idEntity, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sankey/getIndicator/${year}/${idEntity}/lic_mas_ofertas`)
)

export const getBiddingLessOffers = factoryAuthService(({ idEntity, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sankey/getIndicator/${year}/${idEntity}/lic_menos_ofertas`)
)

export const getBiddingNullOffers = factoryAuthService(({ idEntity, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/sankey/getIndicator/${year}/${idEntity}/lic_desiertas`)
)

/**
 * Get the Main Contract Orders (with and without contracts) by Id Entity and Year
 */
export const getWithContract = factoryAuthService(({ idEntity, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/contract/getContract/${idEntity}/${year}/con_contrato`)
)

export const getWithoutContract = factoryAuthService(({ idEntity, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/contract/getContract/${idEntity}/${year}/sin_contrato`)
)

/**
 * Get the detail of each Contract Category (with or without contract)
 */
export const getDetailWithContract = factoryAuthService(({ idEntity, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/contractDetails/getContract/${idEntity}/${year}/con_contrato`)
)

export const getDetailWithoutContract = factoryAuthService(({ idEntity, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/contractDetails/getContract/${idEntity}/${year}/sin_contrato`)
)

/**
 * Get the Contract's by each division: Assets, Services and Others. By Id Entity and Year
 */
export const getContractAssets = factoryAuthService(({ idEntity, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/contract/getByCategory/${idEntity}/${year}/bienes`)
)

export const getContractServices = factoryAuthService(({ idEntity, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/contract/getByCategory/${idEntity}/${year}/servicios`)
)

export const getContractOthers = factoryAuthService(({ idEntity, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/contract/getByCategory/${idEntity}/${year}/otros`)
)

/**
 * Get the Contract's Execution Type. By Id Entity and year
 */
export const getContractInmediate = factoryAuthService(({ idEntity, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/contract/getByExecution/${idEntity}/${year}/ejecucion_inmediata`)
)

export const getContractTime = factoryAuthService(({ idEntity, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/contract/getByExecution/${idEntity}/${year}/ejecucion_tiempo`)
)

export const getContractOtherEx = factoryAuthService(({ idEntity, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/contract/getByExecution/${idEntity}/${year}/otros`)
)

/**
 * Get Contract's Files By Id Entity and year
 */
export const getContractGaranties = factoryAuthService(({ idEntity, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/contract/getByKPI/${idEntity}/${year}/garantias`)
)

export const getContractSanctions = factoryAuthService(({ idEntity, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/contract/getByKPI/${idEntity}/${year}/sanciones`)
)

export const getContractFinished = factoryAuthService(({ idEntity, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/contract/getByKPI/${idEntity}/${year}/terminados`)
)

/**
 * Get Contract's Files Details By Id Entity, type and year
 */
export const getContractDetails = factoryAuthService(({ idEntity, year, type }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/contractDetails/getByKPI/${idEntity}/${year}/${type}`)
)

/**
 * Suppliers Cards: Get the Top Suppliers by Id Entity and Year
 */
export const getTopSuppliers = factoryAuthService(({ idEntity, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/calculoMontoProveedor/getMontoProveedores/${year}/${idEntity}`)
)

/**
 * Suppliers Cards: Get the Supplier's Detail by Id Entity, Org Code and Year
 */
export const getSupplierDetail = factoryAuthService(({ idEntity, dni, year }) =>
  getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/calculoMontoProveedor/getMontoProveedoresDetalle/${year}/${idEntity}/${dni}`
  )
)

/**
 * Provider's Type: Get Provider's Amount by Type. By Id Entity, year
 */
export const getProvidersAmount = factoryAuthService(({ idEntity, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/calculoMontoProveedor/getMontoProveedoresPorTamano/${year}/${idEntity}`)
)

/**
 * Supplier's Amount: Get the entire list of Suppliers and Amounts. By ID Entity and Year
 */
export const getSuppliersAmountList = factoryAuthService(({ idEntity, year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/supplier/getAmountTraded/${idEntity}/${year}`)
)

/**
 * Supplier's Detail: Get the detail of the Supplier's Amount by month.
 */
export const getSupplierAmountDetail = factoryAuthService(({ idEntity, year, dni }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/supplier/getAmountTradedDetails/${idEntity}/${year}/${dni}`)
)

/**
 * Complains: Get the list of Complain's by Id Entity, category and year
 */
export const getComplainsList = factoryAuthService(({ idEntity, year, category }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/getClaims/bytype/${idEntity}/${year}/${category}`)
)

/**
 * Complains: Get the Detail of Complain by Id Entity, category and year
 */
export const getComplainDetail = factoryAuthService(({ idEntity, year, category, type }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/getClaims/details/${idEntity}/${year}/${category}/${type}`)
)

/**
 * Get modality for year
 */
export const getModalityYear = factoryAuthService(({ year }) =>
  getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/home/modalidad/${year}`)
)
